import { render, staticRenderFns } from "./BS_AboutUs.vue?vue&type=template&id=3dac86ca&scoped=true&"
import script from "./BS_AboutUs.vue?vue&type=script&lang=js&"
export * from "./BS_AboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac86ca",
  null
  
)

export default component.exports